import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Kicker, Reveal } from "../components/Reveal";
import { api } from "../lib/api";

const BOOKABLE = [
  { name: "In-Person Consultation", price: "Complimentary", detail: "30 minutes at Salon 406", service: "consult" },
  { name: "Phone Consultation", price: "$60", detail: "20-minute call with Nichole", service: "phone" },
  { name: "Weight Loss Initial Consult", price: "$199", detail: "History, baseline measurements, GLP-1 plan", service: "weight-loss-consult" },
  { name: "Cannabis Card — New Patient", price: "$125", detail: "In-person QMP evaluation", service: "cannabis-new" },
  { name: "Cannabis Card — Renewal", price: "$75", detail: "Telehealth from home", service: "cannabis-renewal" },
];

function price(item) {
  if (item.price === 0) return "$0";
  return item.unit === "starting at" ? `from $${item.price}` : `$${item.price}${item.unit ? ` ${item.unit}` : ""}`;
}

export default function PricingSection() {
  const [menu, setMenu] = useState([]);

  useEffect(() => {
    api.get("/menu").then((res) => setMenu(res.data)).catch(() => setMenu([]));
  }, []);

  return (
    <section id="pricing" data-testid="pricing-section" className="border-t border-linen bg-ivory py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-6 sm:px-8">
        <Reveal>
          <Kicker>Treatments &amp; Prices</Kicker>
          <div className="mt-4 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <h2 className="max-w-xl font-serif text-4xl font-medium leading-tight tracking-tight text-forest sm:text-5xl">
              Honest, simple pricing
            </h2>
            <p className="max-w-md text-sm leading-relaxed text-moss sm:text-base">
              Consultations are complimentary. Book online with no card required
              and pay at your visit.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {BOOKABLE.map((b, i) => (
            <Reveal key={b.service} delay={i * 0.04}>
              <Link to={`/book?service=${b.service}`} data-testid={`pricing-book-${b.service}`} className="block h-full rounded-lg border border-linen p-6 transition-colors duration-300 hover:border-forest/40">
                <p className="font-serif text-2xl font-medium text-forest">{b.price}</p>
                <p className="mt-2 text-sm font-semibold text-forest">{b.name}</p>
                <p className="mt-1 text-xs text-moss">{b.detail}</p>
                <p className="mt-4 text-xs font-semibold uppercase tracking-[0.15em] text-gold-dark">Book &rarr;</p>
              </Link>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 grid gap-x-12 gap-y-12 md:grid-cols-2">
          {menu.map((group, gi) => (
            <Reveal key={group.category} delay={gi * 0.04}>
              <div data-testid={`menu-group-${group.category.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <h3 className="font-serif text-2xl font-medium text-forest">{group.category}</h3>
                <ul className="mt-5 divide-y divide-linen border-t border-linen">
                  {group.items.map((item) => (
                    <li key={item.id} className="flex items-baseline justify-between gap-6 py-3">
                      <div>
                        <p className="text-sm text-forest">{item.name}</p>
                        {item.note && <p className="mt-0.5 text-xs italic text-moss">{item.note}</p>}
                      </div>
                      <p className="shrink-0 text-sm font-semibold text-forest">{price(item)}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-16 flex flex-col gap-4 rounded-lg border border-linen p-7 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="font-serif text-2xl font-medium text-forest">Give the gift of Releaf</p>
              <p className="mt-1 text-sm text-moss">Printable gift certificates for any amount or treatment — paid at the salon.</p>
            </div>
            <Link to="/gift" data-testid="pricing-gift-link" className="rounded-md bg-forest px-6 py-3 text-center text-sm font-semibold text-ivory transition-colors hover:bg-forest-dark">Send a Gift Certificate</Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
